export interface ProjectImage {
  path: string;
  caption: string;
}

export enum ProjectTag {
  PROFESSIONAL_SOFTWARE = 'Professional Software',
  CONTRACT_WORK = 'Contract Work',
  PERSONAL_PROJECT = 'Personal Project',
  IN_DEVELOPMENT = 'In Development',
  OPEN_SOURCE = 'Open Source'
}

export interface TagConfig {
  color: string;
  darkColor: string;
}

export interface Project {
  id: string;
  title: string;
  shortDescription: string;
  longDescription: string;
  technologies: string[];
  images?: ProjectImage[];
  githubUrl?: string;
  liveUrl?: string;
  tags?: ProjectTag[];
}